import React from 'react';
import DealerAd from '../DealerAd/DealerAd';

const App: React.FC = () => {
  if (!window.location.search) {
    return null;
  }
  const params = new URLSearchParams(window.location.search);

  return (
    <DealerAd
      translationVersion={window.__DEALER_T_VERSION__}
      realEstateId={params.get('realEstateId') || ''}
      theme={params.get('theme') || 'dark'}
      offerName={params.get('offerName') || ''}
      width={parseInt(params.get('width') || '', 10)}
      height={parseInt(params.get('height') || '', 10)}
      userGuid={params.get('userGuid') || ''}
      biClientId={params.get('biClientId') || ''}
      biClientIdSigned={params.get('biClientIdSigned') || ''}
      withCloseButton={!!params.get('withCloseButton')}
    />
  );
};

export default App;
